import { withRouter } from 'react-router-dom';
import WithSystem from './../service/WithSystem';
const batchFilter = JSON.parse(window.batchFilter);
class BatchDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.box   = React.createRef();
    this.state ={dropdownToggle:false}
  }
  setBatchItems = (selectedId, event) => {
    let batches = this.props.queryFilter.batches;
    batches = batches ? batches.split(',') : [];
    if (event.target.checked) {
      batches = batches.length ? [...batches, selectedId] : [selectedId];
    } else {
      batches = batches.filter((batch) => {
        return (batch != selectedId);
      });
    }
    batches = batches.length ? batches.join() : false;
    this.props.setGlobalState({ batches });
  }
  SetDropdownToggleVall = ()=>{
    this.setState({dropdownToggle:!this.state.dropdownToggle},()=>{
      document.addEventListener('click', this.handleOutsideClick);
    });
  }
  handleOutsideClick = (event) => {
    if (this.box && !this.box.current.contains(event.target)) {
      this.setState({dropdownToggle:!this.state.dropdownToggle},()=>{
        if (this.state.dropdownToggle == true) {
          this.setState({ dropdownToggle: false });
        }
        document.removeEventListener('click', this.handleOutsideClick);
      });
    }
  }
  render() {
    const batchesItems = this.props.queryFilter['batches'] ? this.props.queryFilter['batches'].split(',') : [];
    return (
      <div ref={this.box} onClick={() => this.SetDropdownToggleVall()} className={this.state.dropdownToggle == true ? 'branch-list active' : 'branch-list'}>
        <span className="filter-subtxt">Batch</span>
          <div className="report-list-menu" >
            <div className="branch-list-sec">Select Batch</div>
              <div className="list_menu_section" >
                <ul className="list_menu">
                  {batchFilter.map((course) => {
                  let hasChecked = batchesItems.includes(course.id);
                  return (
                    <li key={`batch_${course.id}`}>
                    <label>
                    <span>
                          <input id={`batch_${course.id}`} onClick={(e) => this.setBatchItems(`${course.id}`, e)} className="bc_column_visible bc_initial_events uncheckbox" defaultChecked={hasChecked} data-column-name="Attendee Name" type="checkbox" data-field-name="attendee_name" />
                      <span className="checkedmark"></span>
                    </span>
                      <span className="dropdownlist_singleline">{course.gp_institute_code} - {course.gp_name}</span></label></li>)
                  })}
                </ul>
             </div>
           </div>
       </div>
    );
  }
}
export default withRouter(WithSystem(BatchDropDown));
